import { render, staticRenderFns } from "./Consimtamant.vue?vue&type=template&id=bd813e94&scoped=true"
import script from "./Consimtamant.vue?vue&type=script&lang=js"
export * from "./Consimtamant.vue?vue&type=script&lang=js"
import style0 from "./Consimtamant.vue?vue&type=style&index=0&id=bd813e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd813e94",
  null
  
)

export default component.exports